type Props = {
  email: string;
  handleSelectedSuggestionEmail: (selectedEmail: string) => void;
};

const Email = ({ email, handleSelectedSuggestionEmail }: Props) => (
  <div
    className="cursor-pointer rounded-moon-i-xs bg-gohan px-2 py-1 duration-500 ease-in-out hover:scale-110"
    onClick={() => handleSelectedSuggestionEmail(email)}
  >
    {email}
  </div>
);

export default Email;
